import { Injectable } from '@angular/core';

import { pluck } from 'rxjs/operators';

import type { GdprSaveBody } from '@recruitee/gdpr-types';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class GdprConfigurationHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetch() {
    return this.httpApi.get('gdpr/configuration').pipe(pluck('configuration'));
  }

  public save(body: GdprSaveBody) {
    return this.httpApi.patch('gdpr/configuration', null, body).pipe(pluck('configuration'));
  }
}
